import { useState } from "react";

function TaxInfoModal({ onClose, onSubmit, initialValues = {} }) {
  
  const [taxCountry, setTaxCountry] = useState(
    [1, 2, 3].includes(Number(initialValues.tax_country))
      ? Number(initialValues.tax_country)
      : ""
      
  );

  const handleContinue = () => {
    if (typeof onSubmit === "function") {
      onSubmit({ tax_country: taxCountry });
    }
    if (typeof onClose === "function") {
      onClose();
    }
  };

  return (
    <div
      className="modal fade all_modalss shedowww al_boths show"
      style={{ display: "block" }}
      role="dialog"
      aria-modal="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content detailspgess">
          <div className="modal-header">
            <button type="button" className="close" onClick={onClose} aria-label="Close">
              &times;
            </button>
          </div>

          <div className="modal_box checkout">
            <h4>Add Tax Information</h4>
            <p className="tx_titls">
              To get started, select a country/region to add your tax info.
            </p>

            <div className="ckymetntts">
              <div className="bothsredoibtn">
                <label className="label--radio rft">
                  <input
                    className="radio"
                    type="radio"
                    name="tax_country"
                    value={1}
                    checked={taxCountry === 1}
                    onChange={() => setTaxCountry(1)}
                  />{" "}
                  United States
                </label>
              </div>

              <div className="bothsredoibtn">
                <label className="label--radio rft">
                  <input
                    className="radio"
                    type="radio"
                    name="tax_country"
                    value={2}
                    checked={taxCountry === 2}
                    onChange={() => setTaxCountry(2)}
                  />{" "}
                  Mexico, Colombia or India
                </label>
              </div>

              <div className="bothsredoibtn">
                <label className="label--radio rft">
                  <input
                    className="radio"
                    type="radio"
                    name="tax_country"
                    value={3}
                    checked={taxCountry === 3}
                    onChange={() => setTaxCountry(3)}
                  />{" "}
                  Another country/region
                </label>
              </div>
            </div>

            <div className="form-group mb-0">
              <div className="both_areea_btn">
                <button className="clnssel" onClick={onClose} type="button">
                  Close
                </button>
                <button className="btnlinks" onClick={handleContinue} type="button">
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TaxInfoModal;
